import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from 'Components';
import Header from './Header/TestConfigModalTemplateHeader';
import './TestConfigModalTemplate.css';

const TestConfigModalTemplate = ({
  Checked,
  Limit,
  ParameterName,
}) => (
  <tr className="test-config-modal-template">
    <td><CheckBox checked={Checked} onClick={() => null} /></td>
    <td>{ParameterName}</td>
    <td>{Limit}</td>
    <td />
  </tr>
);

TestConfigModalTemplate.propTypes = {
  Checked: PropTypes.bool,
  Limit: PropTypes.string,
  ParameterName: PropTypes.string,
};

TestConfigModalTemplate.Header = Header;

export default TestConfigModalTemplate;



// WEBPACK FOOTER //
// ./src/components/TestConfigModalTemplate/TestConfigModalTemplate.jsx